import { NavigationItemModel } from '../../shared/models/navigation-item-model';
import { LookupService } from '../../shared/services/lookup.service';
import { MenuItem } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-product-purchases-shell',
  templateUrl: './product-purchases-shell.component.html',
  styleUrls: ['./product-purchases-shell.component.less'],
  standalone: false,
})
export class ProductPurchasesShellComponent implements OnInit {
  private lastItem: NavigationItemModel;
  public items: NavigationItemModel[];
  private url: string;

  constructor(
    private lookupService: LookupService,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.url = '/product-purchases';
  }

  ngOnInit() {
    this.lookupService.getCachedLookupData();
    this.items = [
      {
        header: this.translateService.instant('label.CvDatabase'),
        path: 'cv-database-products',
        fullPath: this.url.concat('/cv-database-products'),
      },
      {
        header: this.translateService.instant('label.CvBox'),
        path: 'cv-box-products',
        fullPath: this.url.concat('/cv-box-products'),
      },
      {
        header: this.translateService.instant('label.SliderBanner'),
        path: 'slider-banner-products',
        fullPath: this.url.concat('/slider-banner-products'),
      },
      {
        header: this.translateService.instant('label.Branding'),
        path: 'branding-products',
        fullPath: this.url.concat('/branding-products'),
      },
    ];
    this.lastItem = this.items[this.items.length - 1];
  }
}
